var EventEmitter = require('events').EventEmitter;
var localEmitter = new EventEmitter();

module.exports = localEmitter;